import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-msmecustomfeedback',
  templateUrl: './msmecustomfeedback.component.html',
  styleUrl: './msmecustomfeedback.component.css'
})
export class MsmecustomfeedbackComponent implements OnInit {

  form: FormGroup;
  questions: any;
  data: any;
  questionsBySection: any;
  sections: string[] = [];
  feedbackAnswer: any;
  isDisable: boolean = false;
  dataSource: any = [];
  participants: any = [];
  userType = sessionStorage.getItem('UserType');
  notMSMEUser: boolean = false;
  enrollmentId = sessionStorage.getItem("EnrollmentId");
  
  constructor(private apiService: ApiService, private toastrService: ToastrService, private fb: FormBuilder, private router: Router) {
    this.form = this.fb.group({
      eventId: new FormControl(null),
      eventDate: new FormControl(null),
      time: new FormControl(null),
      udyamRegistrationNumber: new FormControl(null),
      nameOfOrganisation: new FormControl(null),
      interventionName: new FormControl(null),
      interestName: new FormControl(null),

      name: new FormControl(null),
      nameOfEnterprise: new FormControl(null),
      typeOfOrganization: new FormControl(null),
      ownersMobileNumber: new FormControl(null),
      gender: new FormControl(null),
      sector: new FormControl(null),
      socialCategory: new FormControl(null),
      email: new FormControl(null),
      ownersaddress: new FormControl(null),
      officialAddressOfEnterprise: new FormControl(null),
      stateName: new FormControl(null),
      districtName: new FormControl(null),
      block: new FormControl(null),
      city: new FormControl(null),
      pin: new FormControl(null),

    });
  }

  // Load data
  ngOnInit(): void {
    if (this.userType == 'IA' || this.userType == 'MSSIDC') {
      this.notMSMEUser = true;
    }   
    this.LoadDetails();    
  }

  // Load Initial Data
  LoadDetails() {
    var data = {};

    if (this.userType == 'IA' || this.userType == 'MSSIDC') {
      this.data = {
        udyamRegistrationNumber: sessionStorage.getItem('msMeUserName'), //'UDYAM-MH-01-0000030',
        eventId: sessionStorage.getItem("EventId"),//'Emp_CapBul_42',
        EnrollmentId: this.enrollmentId
      }
    }
    if (this.userType == 'MSME') {
      this.data = {
        udyamRegistrationNumber: sessionStorage.getItem('msMeUserName'), //'UDYAM-MH-01-0000030',
        eventId: sessionStorage.getItem("EventId"),//'Emp_CapBul_42',
        EnrollmentId: this.enrollmentId
      }
    } 

    //var data = {
    //  udyamRegistrationNumber: sessionStorage.getItem('msMeUserName'), //'UDYAM-MH-01-0000030',
    //  eventId: sessionStorage.getItem("EventId"),//'Emp_CapBul_42',
    //  EnrollmentId: this.enrollmentId
    //}
    
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETMSMECUSTOMFEEDBACKQUESTION, this.data).subscribe(
      result => {
        if (result.status) {

          //var eventDetails = result.data[0][0];
          //var eventDetails1 = result.data[1][0];
          //var eventDetails3 = result.data[3];
          
          this.form.patchValue(result.data[0][0]);
          this.form.patchValue(result.data[1][0]);
          this.dataSource = result.data[2];
          this.participants = result.data[3][0];
          
          /*this.form.patchValue(result.data.item2);*/

          this.data = result.data[4];
          // Assuming `this.data` contains the raw questions data
          //this.questions = this.questions;

          // Transform the data
          this.questions = this.data.map((item:any) => {
            // Convert the `options` field if it exists
            //const formattedOptions = item.options ? item.options.split(',') : undefined;
            const formattedOptions = item.options ? item.options.split(',').map((opt:any) => opt.trim()) : undefined;
            const formattedRatings = item.rating ? item.rating.split(',').map((rating: any) => rating.trim()) : undefined;

            // Combine options and ratings into an array of objects
            const combinedOptions = formattedOptions && formattedRatings
              ? formattedOptions.map((text:any, index:any) => ({
                text,
                value: formattedRatings[index] || null // Assign null if no matching rating
              }))
              : undefined;

            return {
              interventionId: item.interventionId,
              section:item.section,
              componentId: item.componentId,
              questionId: item.questionId,
              questionText: item.questionText,
              answerType: item.answerType,
              ...(combinedOptions && { options: combinedOptions })
              //...(formattedOptions && { options: formattedOptions }) // Add 'options' only if it exists
            };
          });
          
          this.questionsBySection = this.groupQuestionsBySection(this.questions);
          this.sections = Object.keys(this.questionsBySection); // Extract section names

          // Assuming `feedbackAnswer` is passed to your component or retrieved
          this.feedbackAnswer = result.data[4][0]['feedbackAnswer'];
          

          this.createDynamicForm();

          if (this.feedbackAnswer != null) {
      
            this.patchFeedbackAnswer(this.feedbackAnswer); // Patch the answers
            this.isDisable = true;
            this.disableAllFields();
          } else
            this.disableFormControls();
            
        } else {
          this.toastrService.error(result.message);
        }
      }
    )

  }

  // Disable controls
  disableFormControls() {
    const controlsToDisable = [
      'eventId',
      'eventDate',
      'time',
      'udyamRegistrationNumber',
      'nameOfOrganisation',
      'interventionName',
      'interestName',
      'name',
      'nameOfEnterprise',
      'typeOfOrganization',
      'ownersMobileNumber',
      'gender',
      'sector',
      'socialCategory',
      'email',
      'ownersaddress',
      'officialAddressOfEnterprise',
      'stateName',
      'districtName',
      'block',
      'city',
      'pin',
      'participantName',
      'mobileNumber',
      'emailId',
      'enrollmentId',
      'designation'
    ];

    controlsToDisable.forEach(controlName => {
      const control = this.form.get(controlName);
      if (control) {
        control.disable();
      }
    });
  }

  disableAllFields() {
    Object.keys(this.form.controls).forEach((key) => {
      const control = this.form.get(key);
      
      if (control instanceof FormControl) {
        // Disable individual form controls
        control.disable();
      } else if (control instanceof FormArray) {
        // For FormArray (e.g., Checkboxes)
        control.controls.forEach((arrayControl) => {
          arrayControl.disable();
        });
      }
    });
  }

  // Helper method to group questions by their section
  groupQuestionsBySection(questions: any[]): any {
    return questions.reduce((grouped: any, question: any) => {
      // Check if the section already exists
      if (!grouped[question.section]) {
        grouped[question.section] = [];
      }
      // Add the question to the section group
      grouped[question.section].push(question);
      return grouped;
    }, {});
  }

  // Create dynamic form fields based on question data
  createDynamicForm() {
    this.questions.forEach((question: any) => {
      switch (question.answerType) {
        case 'Text':
          this.form.addControl(
            `question_${question.questionId}`,
            new FormControl('', Validators.required)
          );
          break;

        case 'Radio':
          this.form.addControl(
            `question_${question.questionId}`,
            new FormControl('', Validators.required)
          );
          break;

        case 'Dropdown':
          this.form.addControl(
            `question_${question.questionId}`,
            new FormControl('', Validators.required)
          );
          break;

        case 'Checkbox':
          const checkboxesArray = this.fb.array(
            question.options.map(() => new FormControl(false))
          );
          this.form.addControl(`question_${question.questionId}`, checkboxesArray);
          break;

        default:
          break;
      }
    });
  }

  // Assuming 'feedbackAnswer' is passed to your component
  patchFeedbackAnswer(feedbackAnswer: string) {
    const answers = JSON.parse(feedbackAnswer); // Parse the JSON string

    // Iterate through the answers and patch them to the form
    Object.keys(answers).forEach((key) => {
      // For Checkboxes, handle FormArray
      if (this.form.get(key) instanceof FormArray) {
        const checkboxArray = this.form.get(key) as FormArray;
        const selectedIndexes = answers[key]; // Expected to be an array of selected indexes

        // Patch each checkbox control to match the selected indexes
        checkboxArray.controls.forEach((control, index) => {
          control.setValue(selectedIndexes.includes(index)); // Set 'true' for selected indexes
        });
      } else {
        // For other controls (Text, Radio, Dropdown), patch value directly
        this.form.get(key)?.setValue(answers[key]);
      }
    });
  }

  // Save feedback data
  onSubmit() {

    if (this.form.invalid)
      this.isDisable = false;

    var data = {
      eventId: sessionStorage.getItem("EventId"),
      feedback: JSON.stringify(this.form.value),
      CreatedBy: sessionStorage.getItem('msMeUserId'),
      EnrollmentId: this.enrollmentId,
    }

    this.apiService.postRequest(API_ENDPOINTS.MSME.POSTMSMECUSTOMFEEDBACK, data).subscribe(
      (result: any) => {
        
        this.toastrService.success('Implementation Details added successfully!', 'Good job!');
        this.router.navigate(['/vieweventlist']);
      },
      error => {
        this.toastrService.error(error, 'Information cannot be saved. Please check for errors indicated in red.');
      }
    );

  }

  onPressBack(): void {
    const eventId = sessionStorage.getItem("UniqueEventId");
    if (this.userType == 'IA') {
      this.router.navigate(['/viewFeedbacksListia', eventId]);
    } else if (this.userType == 'MSSIDC') {
      this.router.navigate(['/viewFeedbacksListmssidc', eventId]);
    }

  }
}
